import React, { useState, useEffect } from 'react';
// import belantaraimg  from '../../../assets/discover/belantara-banner.jpeg';
import banner from "../../../assets/sectbanner.webp";
import Footer from '../Footer/Footer'
import '../Activities/ActivitiesPage.css'
import Header from '../Header';
import api from '../../../config/axiosConfig';


function ActivitiesPage() {
  const [activities, setActivities] = useState([]);
  const [activityMedia, setActivityMedia] = useState([]);
       
  useEffect(() => {
    const fetchActivities = async () => {
      try {
        const response = await api.get('items/joined');
        const fetchedMedia = await api.get('/media');
  
  
        const activitiesItem = response.data.filter(
          (item) => item.itemtype_name === "Activity"
        );
  
        setActivities(activitiesItem);
        setActivityMedia(fetchedMedia.data); // Make sure this matches the media array structure
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    fetchActivities();
  }, []);
  

  return (
    <>
      <Header />
      <div className="inner-banner pb-5" id="hero">
        <div className="bannar">
          <img src={banner} alt="banner" loading="lazy" />
        </div>
        <div className="bannar-text-div">
          {/* <p>Located in Sindhudurg, Maharashtra</p> */}
          <h2 className="bannar-text">Activities</h2>
        </div>
      </div>
  
      <section className="activities-inner p-4 p-md-5">
      <div className="activity-box p-md-5 p-3">
  {activities.map((item, index) => {
    const activityMediaItem = activityMedia.find(
      (media) => String(media.itemId) === String(item.item_id)
    );

    const imageUrl = activityMediaItem?.path
      ? `${process.env.REACT_APP_WS_URL}/api/media/mediafiles/${activityMediaItem.path.replace('uploads/mediafiles/', '')}`
      : 'https://via.placeholder.com/300?text=No+Image+Available';

    return (
      <div
        key={index}
        className={`activity-item container ${
          index % 2 === 0 ? 'even-activity' : 'odd-activity'
        } ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}
      >
        <div className="activitycontainer mb-5">
          <div className="activityimgbox">
            <img
              src={imageUrl}
              alt={item.item_name || 'Activity Image'}
              className="activity-image"
              loading="lazy"
              style={{
                height: '50vh',
                width: '100%',
                objectFit: 'cover',
                borderRadius: '10px',
              }}
            />
          </div>
          <div className="activitytextbox p-md-5 p-3">
            <h3 className="activity-title">{item.item_name}</h3>
            <p className="activity-description">
              {item.shortdesc || 'No description available.'}
            </p>
          </div>
        </div>
      </div>
    );
  })}
</div>

      </section>
  
      <Footer />
    </>
  );
}

export default ActivitiesPage;
